<template>
  <div>
    <form-field-input
      label="Label"
      v-model="form.label"
      :validation-errors="validationErrors.label"
    ></form-field-input>

    <form-field-currency
      label="Amount"
      v-model="form.amount"
      :validation-errors="validationErrors.amount"
    ></form-field-currency>

    <form-field-editor
      label="Description"
      v-model="form.description"
      :validation-errors="validationErrors.description"
    />
  </div>
</template>

<script>
import { FormMixin } from "./forms.mixin";
import utils from "../services/utils";
import api from "../api";

export default {
  name: "CampaignCostTemplateForm",
  props: ['formData'],
  mixins: [FormMixin],
  data() {
    return {
      form: {},
      validationErrors: {},
      defaultForm: {
        label: '',
        amount: '',
        description: '',
      },
    }
  },
  created() {
    this.form = (this.formData) ? utils.clone({...this.defaultForm, ...this.formData}) : utils.clone(this.defaultForm);
  },
  methods: {
    create() {
      return api.campaignCostTemplate.create(this.form)
        .then(res => {
          this.$buefy.toast.open({
            message: 'Campaign cost template was created',
            type: 'is-success'
          });

          return res;
        });
    },
    update() {
      return api.campaignCostTemplate.update(this.form)
        .then(res => {
          this.$buefy.toast.open({
            message: 'Campaign cost template was updated',
            type: 'is-success'
          });

          return res;
        });
    },
    delete() {
      return api.campaignCostTemplate.delete(this.form.id)
        .then(res => {
          this.$buefy.toast.open({
            message: 'Campaign cost template was deleted',
            type: 'is-success'
          });

          return res;
        });
    },
  },
};
</script>

<style scoped lang="scss">

</style>
